// extracted by mini-css-extract-plugin
export default {"inputField":"b0o6_z3048eARIQuI8sc","bottomShadow":"nLl9h8XVN4CQ9CkAtCrj"};